import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import SmsSenderAddEdit from "./SmsSenderAddEdit";
import { MenuItem } from "react-bootstrap";
import { PerPage } from "helpers/system-config";
import { CenterFlexRow, BackButton } from "../../styles";
import {
  ModalTrigger,
  ButtonCommonTheme,
  Icon,
  FormControl,
  ActionButtons,
  Table,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  SeachForm,
  SettingDropdownMenu,
  DataWrapperClass,
} from "modules/theme";
import { modalType } from "../../../../../helpers/dotenv";
import { CustomDropdown } from "../../../../common/components";

const defaultColums = [
  "destination",
  "senderId",
  "entityId",
  "company",
  "brandName",
];
class SmsSender extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `SMS Sender`;
    this.moduleUrl = `setting/smsSenderConfig`;
    this.mAPI = new APIManager();
    this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.getList = this.getList.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.search = this.search.bind(this);
    this.handleModalShowColumn = this.handleModalShowColumn.bind(this);
    let selectedColumList = defaultColums;
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      infoData: null,
      showHide: false,
      modalType: modalType,
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      tagList: [],
      search: "",
      assignAry: [],
      tags: [],
      SelectedTagList: [],
      TagChecked: false,
      columnList: defaultColums,
      selectedColumList: selectedColumList,
      showColumnm: false,
    };
    this.getTag();
  }
  componentDidMount() {
    this.getList(this.state.currentPage, this.state.perPageCount);
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    tempList.map((listData) => (listData.selected = e.target.checked));

    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  handleModalShowColumn() {
    this.setState({ showColumnm: !this.state.showColumnm });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });

    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;

    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemTagCheck(e, item) {
    let tempList = this.state.tagList;
    tempList.map((tag) => {
      if (tag._id === item._id) {
        tag.selectedTag = e.target.checked;
      }
      return tag;
    });

    console.log(
      "filter",
      this.state.tagList.filter((e) => e.selectedTag)
    );
    this.setState({
      TagChecked: e.target.checked,
      tagList: tempList,
      SelectedTagList: this.state.tagList.filter((e) => e.selectedTag),
    });
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getList(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  handleModalShowHide(data) {
    this.setState({ showHide: !this.state.showHide });
  }

  getList(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `${this.moduleUrl}?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          const newListData = data.data.map((item) => {
            return {
              ...item,
              selected: false,
            };
          });
          that.setState({
            listData: newListData,
            MasterChecked: false,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  getTag() {
    var that = this;
    this.mAPI.sendGetAPI(
      `setting/tag?limit=10&page_no=1`,
      (data) => {
        if (data && data.data) {
          that.setState({ tagList: data.data });
        } else {
          that.setState({ tagList: [] });
        }
      },
      (error, data) => {}
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getList(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.search);
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  deleteSmsSender(data) {
    var that = this;
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/${data._id}`,
      undefined,
      (data) => {
        this.getList(this.state.currentPage, this.state.perPageCount);
        Alert.success(`${this.moduleName} deleted successfully`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    const list = this.state.SelectedList.map((data) => {
      this.state.ary.push(data._id);
    });
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.setState({ currentPage: 1 });
        this.getList(this.state.currentPage, this.state.perPageCount);
        Alert.success(`${this.moduleName} deleted successfully.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  assignTag(e) {
    const list = this.state.SelectedList.map((data) => {
      this.state.assignAry.push(data._id);
    });
    const tag = this.state.SelectedTagList.map((data) => {
      this.state.tags.push(data.name);
    });
    let tData = {
      module_ids: this.state.assignAry,
      module_name: this.moduleName,
      tags: this.state.tags,
    };
    this.mAPI.sendPostAPI(
      `setting/tag`,
      tData,
      (data) => {},
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  editSmsSender(data) {
    return (
      <ButtonCommonTheme type="edit" editOnClick={() => this.openModal(data)} />
    );
  }

  renderActions(data, index) {
    return (
      <ActionButtons>
        {this.editSmsSender(data)}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem style={{ marginLeft: "0px" }}>
            <a
              onClick={(e) =>
                confirm().then((e) => {
                  this.deleteSmsSender(data, e);
                })
              }
            >
              Delete
            </a>
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  moveCursorAtTheEnd(e) {
    const tmpValue = e.target.value;
    e.target.value = "";
    e.target.value = tmpValue;
  }

  search(e) {
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value, currentPage: 1 });
        this.getList(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  renderActionBar() {
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };

    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title={this.moduleName}
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          openModalShow={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <SmsSenderAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            editData={this.state.editData}
            infoData={this.state.infoData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("SMS Sender"), link: "/settings/sms-sender" },
    ];

    const mainContent = (
      <DataWrapperClass className="tableFixHeadSecondary" overflow="nohide">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th onClick={this.onClick}>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
              </th>
              <th>{__("senderId")}</th>
              <th>{__("DLT Entity/PE Id")}</th>
              <th>{__("destination")}</th>
              <th>{__("company")}</th>
              <th>{__("brandName")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listData.map((data, index) => (
              <tr key={data._id}>
                <td onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={data.selected}
                    onChange={(e) => this.onItemCheck(e, data)}
                  />
                </td>
                <td>{data.senderId}</td>
                <td>{data.entityId}</td>
                <td>{data.destination}</td>
                <td>{data.company}</td>
                <td>{data.brandName}</td>
                <td>{this.renderActions(data, index)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <DataWrapperClass>
        <Wrapper
          header={<Wrapper.Header breadcrumb={breadcrumb} />}
          heading={
            <CenterFlexRow className="header-label">
              <Link className="btn-back" to={`/settings`}>
                <BackButton>
                  <Icon icon="angle-left" size={20} />
                </BackButton>
              </Link>
              <ControlLabel>{`SMS Sender`}</ControlLabel>
            </CenterFlexRow>
          }
          actionBar={
            <Wrapper.ActionBar
              left={
                <div style={{ display: "flex" }}>
                  <SeachForm className="mr-5">
                    <FormControl
                      type="text"
                      placeholder={"Search Here"}
                      onChange={(e) => this.search(e)}
                      value={this.state.searchValue}
                      autoFocus
                    />
                    <span className="material-symbols-outlined">search</span>
                  </SeachForm>
                  {this.state.SelectedList.length > 0 && (
                    <ButtonCommonTheme
                      type="deleteAll"
                      checkboxDeleteOnClick={(e) =>
                        confirm().then((e) => {
                          this.deleteAllData(e);
                        })
                      }
                    />
                  )}
                </div>
              }
              right={this.renderActionBar()}
            />
          }
          footer={
            <ReportPagination
              count={this.state.total}
              onPaginationChange={this.onPaginationChange}
              onPerPageChooser={this.onPerPageChooser}
              currentPage={this.state.currentPage}
              perPage={this.state.perPageCount}
            />
          }
          leftSidebar={<SettingDropdownMenu />}
          showLeftSideBar={true}
          content={
            <div>
              <DataWithLoader
                data={mainContent}
                loading={this.state.loading}
                size={this.state.listData.length}
                count={this.state.listData.length}
                emptyText="Sorry..! No SMS Sender Found"
                emptyImage="/images/emptyimg.png"
              />
            </div>
          }
        />
      </DataWrapperClass>
    );
  }
}

SmsSender.contextTypes = {
  __: PropTypes.func,
};

export default SmsSender;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsSender/components/SmsSender.js